// extracted by mini-css-extract-plugin
export default {"ag-styles":"V_t","toolbar":"V_fm","controlsContainer":"V_fn","controls":"V_x","scrollIndicator":"V_fp","videoTour":"V_fq"};